import { FeatureKind } from "@omni/types/api/product/bff/shared/featureKind.model";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { renderFeature } from "@/components/Product/ProductTile/components/description/description.helpers";

import { ProductFeatureModel } from "../../../helpers";

type FeatureProps = {
    featureModel: ProductFeatureModel;
    featureKind: FeatureKind;
};

const Feature = ({ featureModel, featureKind }: FeatureProps) => {
    const { feature, tooltip } = featureModel;

    return (
        <Col>
            <Row className={cn("tw:border-b tw:border-border")}>
                <Col
                    sm={6}
                    className={cn("tw:bg-grey")}
                >
                    <div className={cn("tw:py-2")}>
                        {feature.name}
                        {feature.toolTipImage && (
                            <Tooltip title={featureKind.name}>
                                <img
                                    className={cn("tw:max-w-full")}
                                    alt={feature.toolTipImage.altText}
                                    src={feature.toolTipImage.url}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </Tooltip>
                        )}
                    </div>
                </Col>
                <Col
                    sm={6}
                    className={cn("tw:bg-background")}
                >
                    <div className={cn("tw:py-2")}>
                        {renderFeature({
                            formattedValues: feature.featureValues.map(
                                (f) => f.formattedValue || ""
                            ),
                            unitName: feature.unit?.name || null
                        })}
                        {tooltip && (
                            <Tooltip title={tooltip.title}>
                                {tooltip.component()}
                            </Tooltip>
                        )}
                    </div>
                </Col>
            </Row>
        </Col>
    );
};

export { Feature };
